import React from "react";
import { AGENCY } from "../mock";
import { ArrowUpRight, Phone, Mail, MapPin } from "lucide-react";

export default function Contact() {
  return (
    <section id="contact" className="relative py-24 md:py-40 px-6 md:px-10 border-t border-white/5 bg-black/25 backdrop-blur-sm">
      <div className="max-w-[1440px] mx-auto">
        <div className="grid md:grid-cols-12 gap-10 md:gap-16 items-center">
          <div className="md:col-span-6">
            <span className="font-mono text-xs uppercase tracking-widest text-[#FF5B24]">
              (06) — Contact
            </span>
            <h2 className="font-display font-medium text-5xl md:text-8xl mt-6 leading-[0.95] tracking-[-0.04em]">
              On <span className="font-serif-i text-[#FF5B24]">se parle</span> ?
            </h2>
            <p className="text-white/70 text-lg mt-8 max-w-md">
              Un projet, une intuition, un doute. On aime les conversations franches.
              Écrivez ou appelez — on répond en 24h.
            </p>

            <a
              href={`mailto:${AGENCY.contact.email}`}
              className="group mt-10 inline-flex items-center gap-3 bg-[#FF5B24] hover:bg-white text-black rounded-full pl-6 pr-2 py-2 font-medium text-sm transition-all"
            >
              Nous écrire
              <span className="w-9 h-9 rounded-full bg-black text-white flex items-center justify-center group-hover:rotate-45 transition-transform">
                <ArrowUpRight className="w-4 h-4" />
              </span>
            </a>
          </div>

          <div className="md:col-span-6">
            <div className="space-y-6">
              <a
                href={`tel:${AGENCY.contact.phone.replace(/\s/g, "")}`}
                className="flex items-center gap-4 group"
              >
                <span className="w-11 h-11 rounded-full border border-white/15 flex items-center justify-center group-hover:bg-[#FF5B24] group-hover:border-[#FF5B24] transition-all">
                  <Phone className="w-4 h-4" />
                </span>
                <div>
                  <div className="font-mono text-[10px] uppercase tracking-widest text-white/40">Téléphone</div>
                  <div className="font-display text-xl group-hover:text-[#FF5B24] transition-colors">
                    {AGENCY.contact.phone}
                  </div>
                </div>
              </a>

              <a href={`mailto:${AGENCY.contact.email}`} className="flex items-center gap-4 group">
                <span className="w-11 h-11 rounded-full border border-white/15 flex items-center justify-center group-hover:bg-[#FF5B24] group-hover:border-[#FF5B24] transition-all">
                  <Mail className="w-4 h-4" />
                </span>
                <div>
                  <div className="font-mono text-[10px] uppercase tracking-widest text-white/40">Email</div>
                  <div className="font-display text-xl group-hover:text-[#FF5B24] transition-colors">
                    {AGENCY.contact.email}
                  </div>
                </div>
              </a>

              <div className="flex items-start gap-4">
                <span className="w-11 h-11 rounded-full border border-white/15 flex items-center justify-center">
                  <MapPin className="w-4 h-4" />
                </span>
                <div>
                  <div className="font-mono text-[10px] uppercase tracking-widest text-white/40">Bureaux</div>
                  <div className="text-white/80 text-sm mt-1 max-w-xs leading-relaxed">
                    {AGENCY.offices.join(" · ")}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
